export default function PolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex justify-center">
          <img src="/images/app-logo-2.svg" alt="ThaiSlipCheck" className="h-12" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-gray max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            นโยบายความเป็นส่วนตัว
          </h1>
          <p className="text-gray-600 mb-8">Privacy Policy</p>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck ให้ความสำคัญกับความเป็นส่วนตัวและความปลอดภัยของข้อมูลผู้ใช้งานเป็นอย่างมาก
            นโยบายฉบับนี้จัดทำขึ้นเพื่ออธิบายถึงวิธีการที่เราเก็บ ใช้ และปกป้องข้อมูลส่วนบุคคลของผู้ใช้งานที่เข้าถึงบริการตรวจสอบสลิปโอนเงินและบริการอื่น
            ๆ บนเว็บไซต์ของเรา
          </p>

          <p className="text-gray-700 leading-relaxed mt-4">
            การเข้าใช้งานเว็บไซต์หมายถึงผู้ใช้ยอมรับนโยบายความเป็นส่วนตัวนี้ หากผู้ใช้ไม่ยอมรับบางส่วนหรือทั้งหมด
            กรุณาหยุดใช้งานเว็บไซต์ทันที
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            1. ข้อมูลที่เราเก็บรวบรวม (Information We Collect)
          </h2>
          <p className="text-gray-700 leading-relaxed">เราอาจเก็บข้อมูลต่อไปนี้จากผู้ใช้</p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            ข้อมูลที่ผู้ใช้ส่งให้โดยตรง
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>ไฟล์สลิปโอนเงิน ภาพถ่าย หรือเอกสารที่ต้องการตรวจสอบ</li>
            <li>ข้อมูลติดต่อ เช่น อีเมล หรือเบอร์โทร (ถ้าผู้ใช้กรอก)</li>
            <li>ข้อมูลที่เกี่ยวข้องกับการตรวจสอบ เช่น เลขอ้างอิง, หมายเหตุ, เวลาทำรายการ</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            ข้อมูลที่ถูกเก็บโดยอัตโนมัติ
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>IP Address, Browser, อุปกรณ์ที่ใช้</li>
            <li>Log การเข้าใช้งาน</li>
            <li>Cookies และข้อมูลพฤติกรรมผู้ใช้งาน</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            2. วัตถุประสงค์ในการใช้ข้อมูล (How We Use Your Information)
          </h2>
          <p className="text-gray-700 leading-relaxed">ข้อมูลที่เก็บจะถูกนำไปใช้เพื่อ:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>ให้บริการตรวจสอบสลิปโอนเงิน</li>
            <li>วิเคราะห์ความถูกต้องของข้อมูลที่ส่งเข้ามา</li>
            <li>ใช้เพื่อความปลอดภัย ป้องกันการฉ้อโกง และตรวจหาการใช้งานที่ผิดปกติ</li>
            <li>พัฒนาประสิทธิภาพเว็บไซต์และการให้บริการ</li>
            <li>ติดต่อกลับผู้ใช้ในกรณีจำเป็น</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            เรา <strong>จะไม่</strong> ขาย แลกเปลี่ยน หรือเผยแพร่ข้อมูลส่วนบุคคลให้บุคคลที่สามโดยไม่ได้รับอนุญาต
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            3. การเก็บรักษาข้อมูล (Data Retention)
          </h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>ข้อมูลสลิปและข้อมูลส่วนตัวจะถูกเก็บรักษาไว้เฉพาะเท่าที่จำเป็น</li>
            <li>ผู้ใช้สามารถร้องขอให้ลบข้อมูลของตนได้</li>
            <li>
              ข้อมูลที่มีความเสี่ยง เช่น ไฟล์สลิป จะถูกลบออกหลังตรวจสอบตามรอบระยะเวลาที่กำหนดเพื่อความปลอดภัย
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            4. การเปิดเผยข้อมูลต่อบุคคลที่สาม (Disclosure to Third Parties)
          </h2>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck อาจเปิดเผยข้อมูลเฉพาะเมื่อจำเป็นเท่านั้น เช่น
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>เมื่อมีข้อกำหนดทางกฎหมาย</li>
            <li>เมื่อหน่วยงานราชการหรือศาลร้องขอ</li>
            <li>เพื่อป้องกันการฉ้อโกงหรือภัยคุกคามต่อระบบ</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            เรา <strong>ไม่อนุญาตให้บุคคลที่สามเข้าถึงข้อมูลสลิปผู้ใช้เพื่อวัตถุประสงค์เชิงพาณิชย์</strong>
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            5. Cookies และเทคโนโลยีติดตามผู้ใช้งาน (Cookies & Tracking)
          </h2>
          <p className="text-gray-700 leading-relaxed">เว็บไซต์อาจใช้ Cookies เพื่อ:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>ปรับปรุงประสบการณ์ผู้ใช้งาน</li>
            <li>วิเคราะห์สถิติการใช้งาน</li>
            <li>ปรับปรุงความปลอดภัย</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            ผู้ใช้สามารถปิด Cookies ผ่านการตั้งค่าเบราว์เซอร์ได้ แต่บางฟีเจอร์ในเว็บอาจทำงานได้ไม่สมบูรณ์
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            6. ความปลอดภัยของข้อมูล (Data Security)
          </h2>
          <p className="text-gray-700 leading-relaxed">เราใช้มาตรการความปลอดภัยรวมถึง:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>HTTPS Encryption</li>
            <li>การควบคุมสิทธิ์เข้าถึงข้อมูล</li>
            <li>ระบบตรวจสอบพฤติกรรมที่ผิดปกติ</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            อย่างไรก็ตาม ไม่มีระบบใดปลอดภัย 100% เราจะดำเนินการอย่างดีที่สุดเพื่อปกป้องข้อมูลของผู้ใช้เสมอ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            7. สิทธิของผู้ใช้งาน (User Rights)
          </h2>
          <p className="text-gray-700 leading-relaxed">ผู้ใช้สามารถร้องขอ:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>เข้าถึงข้อมูลส่วนตัวของตน</li>
            <li>แก้ไขข้อมูลที่ไม่ถูกต้อง</li>
            <li>ลบข้อมูลเมื่อไม่ต้องการให้เก็บต่อ</li>
            <li>ถอนความยินยอมในการประมวลผลข้อมูล</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            ส่งคำขอได้ที่อีเมลหรือช่องทางติดต่อที่ระบุในเว็บไซต์
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            8. การปรับปรุงนโยบาย (Policy Updates)
          </h2>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck อาจปรับปรุงนโยบายนี้เป็นครั้งคราว
            วันที่ปรับปรุงล่าสุดจะแสดงด้านล่างของหน้า ผู้ใช้ควรตรวจสอบอย่างสม่ำเสมอ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. ช่องทางติดต่อ (Contact Us)</h2>
          <p className="text-gray-700 leading-relaxed">
            หากมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัว สามารถติดต่อเราได้ที่:
          </p>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mt-4">
            <h4 className="font-semibold text-gray-900 mb-3">
              บริษัท อีซี่ เทค อีเลฟเว่น จำกัด (สำนักงานใหญ่)
            </h4>
            <p className="text-gray-700 leading-relaxed">
              เลขที่ 18 ซอยประชาชื่นนนทบุรี 8 แยก 1
              <br />
              ตำบลบางเขน อำเภอเมืองนนทบุรี
              <br />
              จังหวัดนนทบุรี 11000
            </p>
            <p className="text-gray-700 mt-2">
              <strong>โทร:</strong> 084-3618424
            </p>
          </div>

          <div className="mt-12 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
            อัปเดตล่าสุด: ธันวาคม 2568
          </div>
        </div>
      </main>
    </div>
  );
}
